import React from 'react';
import s from './HorizontalLine.module.scss';

const HorizontalLine = () => <hr className={s.root} />;

export default HorizontalLine;
